var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceGulfTalent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.9991C22 19.7612 19.7612 22 17.0001 22H6.99995C4.23793 22 2 19.7612 2 16.9991V7.00008C2 4.238 4.23793 2 6.99995 2H17.0001C19.7612 2 22 4.238 22 7.00008L22 16.9991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 5H11.3262C11.3262 5 15.2832 5.8184 16.9071 7.551C18.3068 9.04445 18.9999 12.3129 18.9999 12.3129V6C18.9999 5.44772 18.5522 5 17.9999 5Z",
    fill: "#F02E20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 11.1211L17.9672 9.93064H10.4678V11.1211H13.4327V18.9997H15.0023V11.1211H17.0952Z",
    fill: "url(#paint0_linear_2634_41855)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42139 13.332H11.1654V15.0326C11.1654 15.0326 8.88457 15.373 7.66375 14.3526C6.61668 13.4774 6.26852 12.4819 6.45652 11.1211C6.64944 9.72486 7.64745 8.8018 9.07258 8.57018C10.119 8.40012 12.0375 8.91032 12.0375 8.91032L12.5471 7.7201C12.5471 7.7201 10.803 7.04035 8.53577 7.38043C6.48397 7.68819 5.30913 9.11298 5.04782 11.1212C4.7755 13.2141 5.66808 15.2696 7.67685 16.053C9.42141 16.7334 12.5607 16.053 12.5607 16.053V11.8014H9.42139V13.332Z",
    fill: "url(#paint1_linear_2634_41855)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2634_41855",
    x1: 11.4836,
    y1: 7.28516,
    x2: 11.4836,
    y2: 18.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#361E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11044B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2634_41855",
    x1: 11.4836,
    y1: 7.28516,
    x2: 11.4836,
    y2: 18.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#361E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11044B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceGulfTalent);
export default __webpack_public_path__ + "static/media/source-gulf-talent.1f7e89cd071f15c0def5d935dcc42a2a.svg";
export { ForwardRef as ReactComponent };